import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [currentChapter, setCurrentChapter] = useState('1');
  const [currentVerse, setCurrentVerse] = useState('1');
  const navigate = useNavigate();

  // Stable refs + no-op when value unchanged — avoids unnecessary consumer re-renders
  const updateChapter = useCallback((chapter) => {
    const next = String(chapter);
    setCurrentChapter(prev => (prev === next ? prev : next));
  }, []);

  const updateVerse = useCallback((verse) => {
    const next = String(verse);
    setCurrentVerse(prev => (prev === next ? prev : next));
  }, []);

  const navigateToVerse = useCallback((chapterNum, verseNum) => {
    const nextChapter = String(chapterNum);
    const nextVerse = String(verseNum);
    setCurrentChapter(prev => (prev === nextChapter ? prev : nextChapter));
    setCurrentVerse(prev => (prev === nextVerse ? prev : nextVerse));
    navigate(`/chapters/${chapterNum}/verses/${verseNum}`);
  }, [navigate]);

  const navigateToVerses = useCallback((chapterNum) => {
    const nextChapter = String(chapterNum);
    setCurrentChapter(prev => (prev === nextChapter ? prev : nextChapter));
    navigate(`/chapters/${chapterNum}/verses`);
  }, [navigate]);

  const value = useMemo(() => ({
    currentChapter,
    currentVerse,
    updateChapter,
    updateVerse,
    navigateToVerse,
    navigateToVerses,
  }), [
    currentChapter,
    currentVerse,
    updateChapter,
    updateVerse,
    navigateToVerse,
    navigateToVerses,
  ]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
